import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { admin, adminProfile, isSuperAdmin, logout } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const NAV_LINKS = [
    { to: '/dashboard',        label: 'Dashboard',    icon: '🏠' },
    { to: '/tournaments',      label: 'Tournaments',  icon: '🏆' },
    { to: '/players',          label: 'Players',      icon: '👤' },
    { to: '/leaderboard',      label: 'Leaderboard',  icon: '📊' },
    { to: '/live-scores',      label: 'Live Scores',  icon: '🔴' },
    { to: '/admin-management', label: isSuperAdmin ? 'Admin Panel' : 'My Account', icon: isSuperAdmin ? '🛡️' : '⚙️' },
  ];

  return (
    <nav style={styles.nav}>
      <div style={styles.inner}>
        <Link to="/dashboard" style={styles.logo}>
          <span style={styles.logoIcon}>🏓</span>
          <span style={styles.logoText}>Live Pickle Ball</span>
        </Link>

        {/* Desktop links */}
        <div style={styles.links} className="navbar-links">
          {NAV_LINKS.map(l => (
            <Link
              key={l.to}
              to={l.to}
              style={{
                ...styles.link,
                ...(location.pathname.startsWith(l.to) ? styles.linkActive : {})
              }}
            >
              {l.icon} {l.label}
            </Link>
          ))}
        </div>

        <div style={styles.right}>
          <span style={styles.adminBadge} className="navbar-admin-badge-wrap">
            <span style={{ ...styles.dot, ...(isSuperAdmin ? styles.dotSuperAdmin : {}) }} />
            {admin?.username}
            {isSuperAdmin && <span style={styles.superTag}>SUPER</span>}
          </span>
          <button style={styles.logoutBtn} className="navbar-logout-btn-wrap" onClick={logout}>Logout</button>
          <button style={styles.menuBtn} className="navbar-menu-btn" onClick={() => setMenuOpen(o => !o)}>☰</button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={styles.mobileMenu}>
          {NAV_LINKS.map(l => (
            <Link
              key={l.to}
              to={l.to}
              style={styles.mobileLink}
              onClick={() => setMenuOpen(false)}
            >
              {l.icon} {l.label}
            </Link>
          ))}
          <button style={{ ...styles.mobileLink, background: 'none', border: 'none', color: '#e74c3c', textAlign: 'left', width: '100%' }} onClick={logout}>
            🚪 Logout
          </button>
        </div>
      )}
    </nav>
  );
}

const styles = {
  nav: {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
    background: '#1a2332',
    boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
  },
  inner: {
    maxWidth: '1200px', margin: '0 auto', padding: '0 20px',
    height: '64px', display: 'flex', alignItems: 'center', gap: '24px',
  },
  logo: {
    display: 'flex', alignItems: 'center', gap: '8px', color: '#fff',
    textDecoration: 'none',
  },
  logoIcon: { fontSize: '24px' },
  logoText: { fontSize: '18px', fontWeight: '800', color: '#27ae60' },
  links: { display: 'flex', gap: '2px', flex: 1 },
  link: {
    padding: '6px 10px', borderRadius: '6px', fontSize: '13px', fontWeight: '500',
    color: 'rgba(255,255,255,0.7)', textDecoration: 'none', transition: 'all 0.2s',
    display: 'flex', alignItems: 'center', gap: '5px',
  },
  linkActive: { background: 'rgba(39,174,96,0.2)', color: '#27ae60' },
  right: { display: 'flex', alignItems: 'center', gap: '12px', marginLeft: 'auto' },
  adminBadge: {
    display: 'flex', alignItems: 'center', gap: '6px',
    color: 'rgba(255,255,255,0.8)', fontSize: '13px', fontWeight: '500',
  },
  dot: {
    width: '8px', height: '8px', borderRadius: '50%', background: '#27ae60',
    boxShadow: '0 0 6px rgba(39,174,96,0.6)',
  },
  dotSuperAdmin: { background: '#f39c12', boxShadow: '0 0 6px rgba(243,156,18,0.6)' },
  superTag: {
    fontSize: '10px', fontWeight: '800', color: '#f39c12',
    background: 'rgba(243,156,18,0.15)', padding: '1px 6px', borderRadius: '4px',
    letterSpacing: '0.5px',
  },
  logoutBtn: {
    background: 'rgba(231,76,60,0.15)', color: '#e74c3c', border: '1px solid rgba(231,76,60,0.3)',
    padding: '6px 14px', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
  },
  menuBtn: {
    background: 'none', border: 'none', color: '#fff', fontSize: '22px', cursor: 'pointer',
  },
  mobileMenu: {
    background: '#1a2332', borderTop: '1px solid rgba(255,255,255,0.1)',
    padding: '12px 20px', display: 'flex', flexDirection: 'column', gap: '4px',
  },
  mobileLink: {
    color: 'rgba(255,255,255,0.8)', padding: '10px 14px', borderRadius: '6px',
    display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: '500',
  },
};
